export const cleanAddress = addressLine => {
  return addressLine == null ? void 0 : addressLine.split(',').filter(word => !!word.trim()).join(',').trim();
};
//# sourceMappingURL=cleanAddress.js.map